@use "variables" as *;

.cancelButton {
  color: indianred;
}

.textField {
  height: 60px;
}

.freeTextFields {
  height: 200px;
}

.orientation {
  padding-left: 0 !important;
  padding-right: 0 !important;
  padding-top: 0 !important;
  margin-bottom: $spacing-s;
}

.loadingDiv {
  width: 50px;
  padding-left: $spacing-m;
}

.selectTheme {
  margin-bottom: $spacing-s;
}

.subtitle {
  font-size: $fontSize-xs;
}

.descriptionCard {
  margin-bottom: $spacing-s;
  border-radius: 12px !important;
}

.toggleButton {
  width: 100%;
}

.switch {
  margin-bottom: $spacing-s;
}

.imageDiv {
  width: 40px;
  height: 20px;
  border-style: solid;
  border-width: 2px;
  border-color: black;
}
